import { useGridApiContext, type GridStateColDef } from "@mui/x-data-grid-premium";
import type { Transaction } from "features/transactions/types";
import { useTransactionContext } from "./TransactionProvider";

export const useTransactionDetails = () => {
    const transaction = useTransactionContext();
    const { current: gridApiContext } = useGridApiContext();

    const fromColumns = () => (
        gridApiContext
            .getAllColumns()
            .filter(({ hide }) => hide)
    );

    const renderDetailRow = (column: GridStateColDef<Transaction>) => {
        const renderer = getMethod(column, 'renderCell');
        const formater = getMethod(column, 'valueFormatter');

        return renderer({
            value: formater({
                value: transaction[column.field as keyof Transaction]
            })
        })
    };

    return {
        children: transaction.children,
        fromColumns,
        renderDetailRow
    };
};

export default useTransactionDetails;

function getMethod<T extends { readonly value: keyof Transaction }>(
    column: any,
    methodName: 'renderCell' | 'valueFormatter'
) {
    return (methodName in column)
        ? column[methodName]
        : (({ value }: T) => value);
}
